// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#login-subtitle[data-v-10b03d4c]{margin-top:16px}", ""]);
// Exports
module.exports = exports;
